import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import TreeViewViewModel from '@/ViewModels/Controls/TreeViewViewModel';

export default class PanelBarItemViewModel extends ControlViewModel {

    /**
     * Gibt an, ob das Item ausgeklappt ist
     */
    public isExpanded: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob das Item selektiert ist
     */
    public isSelected: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob das Item auf die volle Höhe skaliert wird
     */
    public hasFullHeight: KnockoutObservable<boolean>;

    /**
     * Enthält ein Label
     */
    public label: LabelViewModel;

    /**
     * Enthält ein TreeView
     */
    public treeView: TreeViewViewModel;

    /**
     * Das ViewModel für ein PanelBarItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.isExpanded = this.observableOrDefault(params.isExpanded, true);
        this.isSelected = this.observableOrDefault(params.isSelected, false);
        this.hasFullHeight = this.observableOrDefault(params.hasFullHeight, false);
        this.label = this.paramOrDefault(params.label, null);
        this.treeView = this.paramOrDefault(params.treeView, null);
    }
}

ComponentManager.setViewModel('PanelBarItemViewModel', PanelBarItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');